import React from 'react';
import { Spacing } from 'apps/sigma2-ui/src/components/ui/Spacing';
import { S2Typography } from 'apps/sigma2-ui/src/components/ui/Typography';
import { useLanguage } from 'apps/sigma2-ui/src/lib/hooks/useLanguage';

export const DeepDiveSection: React.FC<{
  readyToDisplayDynamicContent: boolean;
  recommendedSolutions: React.ReactNode | null;
  filterBar: React.ReactNode;
  overviewCard: React.ReactNode;
  treatmentSelectionModal: React.ReactNode;
}> = ({
  readyToDisplayDynamicContent,
  filterBar,
  overviewCard,
  recommendedSolutions,
  treatmentSelectionModal,
}) => {
  const language = useLanguage();

  return (
    <Spacing size={'xl'} direction={'vertical'}>
      <S2Typography
        translatedContent={language.dataIntelligenceDeepDive()}
        variant={'headline-5'}
      />
      {filterBar}

      {overviewCard}

      {readyToDisplayDynamicContent && recommendedSolutions}

      {treatmentSelectionModal}
    </Spacing>
  );
};
